export default (shop) => {
    const arraysEqual = (array1, array2) => { // if equals => holiday is only one day long => button stays enabled
        if (!Array.isArray(array1) || ! Array.isArray(array2) || array1.length !== array2.length)
        return false;

        const arr1 = array1.concat().sort();
        const arr2 = array2.concat().sort();

        for (let i = 0; i < arr1.length; i++) {
            if (arr1[i] !== arr2[i])
                return false;
        }
        return true;
    }

    if (shop.holidays[0]) {
        const fromDateArray = shop.holidays[0].from.split('-');
        const toDateArray = shop.holidays[0].till.split('-');
        const currentDateFormat = new Date();
        const startDateFormat = new Date(`${fromDateArray[0]}-${parseInt(fromDateArray[1])}-${parseInt(fromDateArray[2])}`);
        const endDateFormat = new Date(`${toDateArray[0]}-${parseInt(toDateArray[1])}-${parseInt(toDateArray[2])}`);

        const startDisableDate = startDateFormat.setDate(startDateFormat.getDate()- 2);
        const endDisableDate = endDateFormat.setDate(endDateFormat.getDate()- 1);
        const currentDate = currentDateFormat.setDate(currentDateFormat.getDate());

        if (!arraysEqual(fromDateArray, toDateArray) && currentDate >= startDisableDate && currentDate < endDisableDate ) {
            return true;
        }
        return false;
    }
};
